import { Select } from 'antd'

import Loader from '@/components/Atoms/Loader/Loader'
import {
  getSlotLabel,
  isSlottedCharacteristicType,
} from '@/utils/search/characteristics/slottedCharacteristics'

import type {
  AvailableCharacteristic,
  EmptyCharacteristicsFilter as EmptyFilterValue,
} from '../../../AttributeProcessing.types'
import filtersCn from '../FiltersPanel/FiltersPanel.module.scss'
import TriStateToggle from '../TriStateToggle/TriStateToggle'
import cn from './EmptyCharacteristicsFilter.module.scss'

const MAX_SLOT_NUMBER = 5

const SLOT_OPTIONS = Array.from({ length: MAX_SLOT_NUMBER }, (_, index) => ({
  value: index + 1,
  label: getSlotLabel(index + 1),
}))

interface EmptyCharacteristicsFilterProps {
  value: EmptyFilterValue
  characteristics: AvailableCharacteristic[]
  loading: boolean
  onOpen: () => void
  onChange: (value: EmptyFilterValue) => void
}

function EmptyCharacteristicsFilter({
  value,
  characteristics,
  loading,
  onOpen,
  onChange,
}: EmptyCharacteristicsFilterProps) {
  const slottedSelected = characteristics.filter(
    (chrc) =>
      value.codes.includes(chrc.code) && isSlottedCharacteristicType(chrc.type)
  )

  const handleCodesChange = (codes: number[]) =>
    onChange({
      ...value,
      codes,
      slots: Object.fromEntries(
        Object.entries(value.slots).filter(([code]) =>
          codes.includes(Number(code))
        )
      ),
    })

  return (
    <>
      <div className={filtersCn.filterRow}>
        <label>Незаполненные характеристики</label>
        <TriStateToggle
          label="Есть"
          value={value.hasEmptyCharacteristics}
          onChange={(hasEmptyCharacteristics) =>
            onChange({ ...value, hasEmptyCharacteristics })
          }
        />
      </div>

      <div className={filtersCn.filterRow}>
        <label>Не заполнена характеристика</label>
        <Select
          mode="multiple"
          className={filtersCn.filterSelect}
          placeholder="Выберите характеристики"
          value={value.codes}
          onChange={handleCodesChange}
          onOpenChange={(open) => {
            if (open) onOpen()
          }}
          loading={loading}
          notFoundContent={loading ? <Loader size={18} /> : undefined}
          showSearch
          optionFilterProp="label"
          options={characteristics.map((chrc) => ({
            value: chrc.code,
            label: chrc.name,
          }))}
          maxTagCount="responsive"
        />
      </div>

      {slottedSelected.map((chrc) => (
        <div key={chrc.code} className={filtersCn.filterRow}>
          <label className={cn.slotLabel} title={chrc.name}>
            {chrc.name}: пустые слоты
          </label>
          <Select
            mode="multiple"
            className={filtersCn.filterSelect}
            placeholder="Вся характеристика"
            value={value.slots[String(chrc.code)] ?? []}
            onChange={(slots: number[]) =>
              onChange({
                ...value,
                slots: { ...value.slots, [String(chrc.code)]: slots },
              })
            }
            options={SLOT_OPTIONS}
            maxTagCount="responsive"
          />
        </div>
      ))}
    </>
  )
}

export default EmptyCharacteristicsFilter
